import { useMemo } from 'react';

export default (t) => useMemo(() => ({
  identifier: {
    name: t('attributeDeviceIdentifier'),
    type: 'string',
    property: true,
  },
  lowTemp: {
    name: t('attributeDeviceLowTemp'),
    type: 'number',
  },
  hiTemp: {
    name: t('attributeDeviceHiTemp'),
    type: 'number',
  },
  eventGroupingDelay: {
    name: t('attributeDeviceEventGroupingDelay'),
    type: 'number',
  },
  eventSmsDelay: {
    name: t('attributeDeviceEventSmsDelay'),
    type: 'number',
  },
  isFreezer: {
    name: t('attributeDeviceIsFreezer'),
    type: 'boolean',
  },
  isLine: {
    name: t('attributeDeviceIsLine'),
    type: 'boolean',
  },
  recordCount: {
    name: t('attributeDeviceRecordCount'),
    type: 'string',
  }
}), [t]);
